import { NavLink } from "react-router-dom";
import { ReactComponent as LogoMultB } from "../../icons/svg/LogoMultb.svg";
import { LogoStyle } from "./style";

export function Logo() {
  return (
    <LogoStyle>
      <NavLink exact to="/"  style={{ textDecoration: 'none', outline: "none" }}>
        <LogoMultB style={{ outline: "none"}} focusable={false}/>
      </NavLink>
    </LogoStyle>
  );
}
